import { render, staticRenderFns } from "./login-oauth.vue?vue&type=template&id=2fb07d9c&scoped=true&"
import script from "./login-oauth.vue?vue&type=script&lang=js&"
export * from "./login-oauth.vue?vue&type=script&lang=js&"
import style0 from "./login-oauth.vue?vue&type=style&index=0&id=2fb07d9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb07d9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCol,VIcon})
